module.exports = __webpack_public_path__ + "static/media/checkboxes6.f4853386.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/website/benefits/checkboxes6.png
// module id = 986
// module chunks = 0